import React from "react";
import { AbsoluteFill, interpolate, spring, useCurrentFrame, useVideoConfig } from "remotion";
import { COLORS, FONTS, SPRING, STAKE } from "./constants";
import { Backdrop, SceneTitle, glow } from "./shared";

const PROBLEMS = [
  { n: "01", label: "Knowledge lives only in your head",     detail: "Every pricing decision, every lost deal." },
  { n: "02", label: "Same questions, every week",             detail: "Team interrupts you to ask what they already asked." },
  { n: "03", label: "30-day ramp for every new hire",         detail: "Nothing is written down. You are the documentation." },
  { n: "04", label: "Playbook walks out the door",            detail: "Best rep quits — half your company goes with them." },
  { n: "05", label: "Enterprise tools priced you out",        detail: "$15–25/seat. 500-seat minimum. You have 5." },
];

export const Scene04FounderProblem: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps, durationInFrames } = useVideoConfig();

  const fade = interpolate(frame, [durationInFrames - 30, durationInFrames], [1, 0], {
    extrapolateLeft: "clamp", extrapolateRight: "clamp",
  });

  const titleAp = interpolate(spring({ frame, fps, config: SPRING.snappy }), [0, 1], [0, 1], {
    extrapolateLeft: "clamp", extrapolateRight: "clamp",
  });

  // Camera orbit (subtle rotate)
  const camRotY = Math.sin(frame * 0.008) * 4;

  return (
    <AbsoluteFill style={{ background: COLORS.bg, opacity: fade, overflow: "hidden" }}>
      <Backdrop frame={frame} accent={STAKE.founder} />

      <SceneTitle
        text="The Founder"
        subtitle="You are the system — and that's the problem."
        color={STAKE.founder}
        frame={frame}
        appear={titleAp}
      />

      {/* 3D stacked problem cards */}
      <div style={{
        position: "absolute",
        top: 240,
        left: "50%",
        transform: `translateX(-50%) perspective(1600px) rotateY(${camRotY}deg) rotateX(6deg)`,
        width: 1400,
        height: 720,
        transformStyle: "preserve-3d",
      }}>
        {PROBLEMS.map((p, i) => {
          const delay = 30 + i * 45;
          const sp = spring({ frame: frame - delay, fps, config: SPRING.slow });
          const op = interpolate(sp, [0, 1], [0, 1], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
          const tx = interpolate(sp, [0, 1], [-200, 0], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
          const tz = interpolate(sp, [0, 1], [-400, 0], { extrapolateLeft: "clamp", extrapolateRight: "clamp" });
          const hover = Math.sin(frame * 0.018 + i * 0.8) * 6;
          return (
            <div key={p.n} style={{
              position: "absolute",
              top: i * 120 + hover,
              left: i * 30 + 80,
              width: 1200,
              opacity: op,
              transform: `translateX(${tx}px) translateZ(${tz}px)`,
              transformStyle: "preserve-3d",
            }}>
              <div style={{
                background: `linear-gradient(135deg, ${COLORS.neonRed}20, ${COLORS.bgCard}ee)`,
                border: `2px solid ${COLORS.neonRed}66`,
                borderLeft: `6px solid ${COLORS.neonRed}`,
                borderRadius: 16,
                padding: "22px 38px",
                boxShadow: `0 0 40px ${COLORS.neonRed}33, 0 20px 40px rgba(0,0,0,0.5)`,
                display: "flex",
                alignItems: "center",
                gap: 28,
              }}>
                <div style={{
                  fontSize: 48,
                  fontFamily: FONTS.mono,
                  fontWeight: 900,
                  color: COLORS.neonRed,
                  opacity: 0.6,
                  minWidth: 80,
                  textShadow: glow(COLORS.neonRed),
                }}>{p.n}</div>
                <div style={{ flex: 1 }}>
                  <div style={{
                    fontSize: 34,
                    fontFamily: FONTS.heading,
                    fontWeight: 800,
                    color: COLORS.textPrimary,
                    letterSpacing: -0.5,
                  }}>
                    {p.label}
                  </div>
                  <div style={{
                    fontSize: 22,
                    fontFamily: FONTS.body,
                    color: COLORS.textSecondary,
                    marginTop: 6,
                  }}>
                    {p.detail}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </AbsoluteFill>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
